import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HintMusicThModule } from './hint-music-th/hint-music-th.module';
import { HomeModule } from './home/home.module';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, AppRoutingModule,HomeModule,HintMusicThModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
